<template>
  <div class="desktop-nav" v-if="windowWidth >= 1920 || !isOpenCategory">
    <TopAppBarDrawerMember v-if="token" @closeDrawer="closeDrawer"
                           @openPattenDialog="openPattenDialog"></TopAppBarDrawerMember>
    <TopAppBarDrawerGuest v-else @closeDrawer="closeDrawer"></TopAppBarDrawerGuest>
    <profile-photo-type v-if="token"></profile-photo-type>
  </div>
</template>

<script>
/**
 * 네비게이션 드로워 메인 컴포넌트(navigation drawer main Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBarDrawerMember from './TopAppBarDrawerMember.vue'
import TopAppBarDrawerGuest from './TopAppBarDrawerGuest.vue'
import ProfilePhotoType from "@/components/common/ProfilePhotoType";

import loginApi from '@/api/loginApi.js'

import {MDCDialog} from "@material/dialog";
import { mapState } from 'vuex';

export default {
  props: ['isDrawerOpen'],

  components: {
    TopAppBarDrawerMember,
    TopAppBarDrawerGuest,
    'profile-photo-type': ProfilePhotoType
  },

  data() {
    return {
      token: '',
      routeName: '',
      windowWidth: 0
    }
  },

  watch: {
    'isDrawerOpen'(value) {
      this.drawer.open = this.isDrawerOpen
    },
  },

  created() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.getBrowserWidth);
  },

  mounted() {
    this.token = localStorage.getItem('token')
    this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
    this.pattenDialog.listen('MDCDialog:opened', () => {
    })
  },

  destroyed() {
    document.body.style.overflow = '';
    window.removeEventListener("resize", this.getBrowserWidth);
  },

  computed: {
    getRouterName() {
      return this.$router.name
    },
    ...mapState({
      isOpenCategory: (state) => state.nav.isOpenCategory
    })
  },

  methods: {
    openPattenDialog() {
      this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
      this.pattenDialog.open()
    },

    closePattenDialog() {
      this.pattenDialog.close();
      localStorage.removeItem("cameraFile");
    },

    closeDrawer() {
      this.drawer.open = false
    },

    checkLogin() {
      return new Promise((resolve, reject) => {
        if (localStorage.getItem('token')) {
          // 로그인 토큰 유효성 체크(check auth token validation)
          loginApi.validToken().then((response) => {
            resolve()
          }).catch((err) => {
            localStorage.removeItem('token')
            resolve()
          })
        } else {
          resolve()
        }
      })
    },

    getBrowserWidth() {
      this.windowWidth = window.innerWidth;
      const mdcDrawerModal = document.querySelector(".mdc-drawer");
      if (mdcDrawerModal) {
        mdcDrawerModal.style.transform = "translateX(0)";
      }
    }
  }
}
</script>